import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { ListRentalHistoryParams, ListRentalHistoryResponse } from './types/rental'

export const rentalHistoryApi = createApi({
	reducerPath: 'rentalHistoryApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['RentalHistory'],
	endpoints: (builder) => ({
		listRentalHistory: builder.query<ListRentalHistoryResponse, ListRentalHistoryParams>({
			query: ({ rentalId, ...params }) => ({
				url: `/rent/${rentalId}/history`,
				params,
			}),
			providesTags: (_r, _e, { rentalId }) => [{ type: 'RentalHistory', id: rentalId }],
		}),
	}),
})

export const { useListRentalHistoryQuery } = rentalHistoryApi
